import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect, useHistory } from 'react-router-dom';
import './index.css';
import style from '../Home/View/IndexView/IndexView.scss'
import { Icon, Toast, Grid, List } from 'antd-mobile';
import { api } from '../../common/app';
import imgbar from '../../assets/frame.png';
import imgbutton from '../../assets/button.png';
import imgsign from '../../assets/sign-up.png';
import imgpay from '../../assets/my_center/pay.png';
import imgreimburse from '../../assets/my_center/reimburse.png';
import imgtrip from '../../assets/my_center/trip.png';
import imghotel from '../../assets/my_center/hotel.png';
import imgplane from '../../assets/my_center/plane.png';
import imglive from '../../assets/live.png';
import MineModal from './component/modal'


export default (props: any) => {
  const history = useHistory();
  // 获取id
  let hash = window.location.hash;
  let hasharray = hash.split('/');
  const meetid: any = hasharray[hasharray.length - 1];

  // 会议信息
  const [meetinfo, setMeetinfo] = useState({} as any);
  // 用户信息
  const [userinfo, setUserinfo] = useState({} as any);
  // 显示模块
  const [modelList, setModelList] = useState([] as any[]);
  // 直播地址
  const [liveLink, setLiveLink] = useState('');

  // 我的
  const [mineData, setMineData] = useState('');
  // 
  const [qrVisible, setQrVisible] = useState(false);

  useEffect(() => {
    (api as any).getLiveLink({ meetid })
      .then((result: any) => {
        if (result.code === 200) {
          setLiveLink(result.result.live_link);
        }
      }).catch((err: any) => {
        Toast.fail(err.message || '接口请求失败');
      });
  }, []);

  useEffect(() => {
    (api as any).getUserInfoIndex({ meetid })
      .then((result: any) => {
        if (result.code === 200) {
          setMineData(result.result);
        }
      }).catch((err: any) => {
        Toast.fail(err.message || '接口请求失败');
      });
  }, [])

  useEffect(() => {
    setModelList([
      {
        id: 1,
        title: "报名",
        icon: imgsign,
        type: 'form',
        url: `/mine/register/${meetid}`,
        style: { width: 30, height: 31 }
      },
      {
        id: 1,
        title: "缴费",
        icon: imgpay,
        type: 'page',
        url: '/home/pay',
      },
      {
        id: 1,
        title: "报销",
        icon: imgreimburse,
        type: '',
        style: { width: 30, height: 23 }
      },
      {
        id: 1,
        title: "我的行程",
        icon: imgtrip,
        type: 'page',
        url: '/mine/trip/index',
        style: { width: 27, height: 30 }
      },
      {
        id: 1,
        title: "酒店",
        icon: imghotel,
        type: 'page',
        url: '/mine/hotel/index',
        style: { width: 28, height: 29 }
      },
      {
        id: 1,
        title: "接送机",
        icon: imgplane,
        type: 'page',
        url: '/mine/plane/index',
        style: { width: 27, height: 27 }
      }
    ])
  }, []);

  useEffect(() => {
    (api as any).getMeetingIndex(meetid).then(
      (res: any) => {
        if (res.code === 200) {
          setMeetinfo(res.result);
        }
      },
      (err: any) => {
        console.log(err);
      }
    );

    (api as any).userInfo({ meetid: meetid })
      .then((result: any) => {
        console.log('userinfo', result);
        setUserinfo(result.result);
      }).catch((err: any) => {
        Toast.fail(err.message || '接口请求失败');
      });
  }, []);

  const onLive = () => {
    if (liveLink === '') {
      Toast.show('暂时没有直播内容');
      return;
    }

    window.location.href = liveLink;
  }

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        //   overflow: auto;
        backgroundColor: '#fff'
      }}
    >
      <div className='mine-cover'>
        <div className='mine-cover-content'>
          <div className='mine-cover-content-detail'>
            <div className='mine-cover-content-detail-title'>{userinfo?.username || '请先登录'}</div>
            <div className='mine-cover-content-detail-qr' onClick={() => {
              if (mineData) {
                setQrVisible(true)
              } else {
                Toast.info('请先登录！', 1);
                setTimeout(() => {
                  history.push(`/home/register/${meetid}`);
                }, 1000);
              }
            }}>查看二维码</div>
          </div>
          <div className='mine-cover-content-cover' style={{ backgroundImage: `url(${userinfo?.headimgurl})` }} />
        </div>

        <div className='mine-cover-bar'>
          <div className='mine-cover-bar-box' style={{ backgroundImage: `url(${imgbar})` }}>
            <div className='mine-cover-bar-title'>{meetinfo.title || '未知'}</div>
            <div className='mine-cover-bar-button' style={{ backgroundImage: `url(${imgbutton})` }} onClick={() => history.push(`/mine/meet/index/${meetid}`)}>
              切换会议
            </div>
          </div>
        </div>
      </div>

      <Grid
        data={modelList}
        columnNum={3}
        square={false}
        hasLine={false}
        onClick={(item: any, index) => {
          console.log('item', item);
          switch (item.type) {
            case 'page': {
              history.push(`${item.url}/${meetid}`)
              break;
            }
            case "form":
              history.push(`${item.url}`)
              break;
            default:
              alert("未知选项");
          }
        }}
        renderItem={(item: any, index) => (
          <div className={style.listItem} style={{ paddingTop: 15, paddingBottom: index > 3 ? 15 : 0 }}>
            <div className={style.itemImgBox}>
              <img className={style.itemImg} style={{ width: 30, height: 30 }} src={item.icon} alt="" />
            </div>
            <div className='mine-tab-text'>{item.title}</div>
          </div>
        )}
      />
      <div style={{ width: '100%', height: '10px', backgroundColor: '#f6f6f6' }} />
      <List>
        <List.Item style={{ paddingLeft: 38, paddingRight: 28, paddingTop: 27, paddingBottom: 27 }} thumb={imglive} arrow='horizontal' onClick={onLive}>
          <div className='mine-list-title'>直播</div>
        </List.Item>
      </List>

      <MineModal
        data={mineData}
        visible={qrVisible}
        onClose={() => setQrVisible(false)}
      />
    </div>
  )
}